import {
  DailyLegLoadFrequencyEditor,
  DailyLegLoadFrequencyFilters
} from '../../models/daily-leg-loads/daily-leg-load.models';
import { Injectable } from '@angular/core';
import { AppConfig } from '../../app/app.config';
import { HttpClient } from '@angular/common/http';
import { DateService } from '../date/date.service';
import { DateParserService } from '../daily-log/daily-log-time/date-parser-service';
import { TimeZoneService } from '../time-zone/time-zone.service';
import { ChangeHistorySummary } from '../../models/change-history/change-history.models';
import { DateTime } from 'luxon';

@Injectable()
export class DailyLegLoadFrequencyService {

  config = AppConfig.settings;

  constructor(
    private http: HttpClient,
    private dateService: DateService,
    private dateParserService: DateParserService,
    private timeZoneService: TimeZoneService
  ) {
  }

  async getDailyLegLoadFrequencyEditor(filters: DailyLegLoadFrequencyFilters): Promise<DailyLegLoadFrequencyEditor>  {
    filters.date = this.dateParserService.removeOffsetFromLuxonDate(filters.date);

    const url = `${this.config.apiUrl}api/dailylegload/frequency/get`;
    const result = await this.http
      .post<DailyLegLoadFrequencyEditor>(url, filters)
      .toPromise();

    return (await this.setFrequencyEditorLocalDates([result]))[0];
  }

  async saveDailyLegLoadFrequencyEditor(editor: DailyLegLoadFrequencyEditor): Promise<number> {
    editor = this.dateParserService.removeOffsetFromLuxonDates(editor);

    const url = `${this.config.apiUrl}api/dailylegload/frequency/save`;

    return this.http
      .post<number>(url, editor)
      .toPromise()
      .then((res: number) => {
        return res;
      });
  }

  async deleteDailyLegLoadFrequencyEditor(editor: DailyLegLoadFrequencyEditor): Promise<void> {
    const url = `${this.config.apiUrl}api/dailylegload/frequency/delete`;

    await this.http.post<void>(url, editor).toPromise();
  }

  async getGridData(dailyLogDate: DateTime): Promise<DailyLegLoadFrequencyEditor[]> {
    const dateLong = dailyLogDate.toMillis();
    const url = `${this.config.apiUrl}api/dailylegload/frequency/${dateLong}`;

    let result = await this.http.get<DailyLegLoadFrequencyEditor[]>(url).toPromise();

    result = await this.setFrequencyEditorLocalDates(result);

    return result;
  }

  private async setFrequencyEditorLocalDates(frequencyEditors: DailyLegLoadFrequencyEditor[]): Promise<DailyLegLoadFrequencyEditor[]> {
    for (let i = 0; i < frequencyEditors.length; i++) {
      frequencyEditors[i].effectiveFromDate = await this.dateParserService.deserializePtLuxonDate(frequencyEditors[i].effectiveFromDate, this.timeZoneService, frequencyEditors[i].effectiveFromDateOffset);

      if (frequencyEditors[i].effectiveFromDate && frequencyEditors[i].effectiveFromDate.dateTime) {
        frequencyEditors[i].effectiveFromDateShow = this.dateService.setFullTimeString(frequencyEditors[i].effectiveFromDate.dateTime);
      }
    }

    return frequencyEditors;
  }
}



// WEBPACK FOOTER //
// ./src/services/daily-leg-loads/daily-leg-load-frequency.service.ts